<template>
  <div :style="styles.container">
    <h2>Reset Password</h2>
    <div v-if="token">
      <form
        :style="styles.form"
        @submit.prevent="submitNewPassword"
      >
        <p>Please use the form below to create a new password.</p>
        <div :style="styles.inputWrap">
          <span :style="styles.inputLabel">New Password</span>
          <input
            class="input__text"
            type="password"
            v-model="pswd1"
            placeholder="your new password"
            required
          >
        </div>
        <div :style="styles.inputWrap">
          <span :style="styles.inputLabel">New Password Again</span>
          <input
          class="input__text"
            type="password"
            v-model="pswd2"
            placeholder="your new password again"
            required
          >
        </div>
        <button type="submit" class="button__submit">Reset Password &rarr;</button>
      </form>
    </div>
    <div v-if="!token">
      <div v-if="!emailSent && !formSubmitted">
        <form
          :style="styles.form"
          @submit.prevent="submitReset"
        >
          <div :style="styles.inputWrap">
            <span :style="styles.inputLabel">Email Address</span>
            <input
            class="input__text"
              type="email"
              placeholder="you@somewhere.com"
              v-model="email"
              required
            >
          </div>
          <button type="submit" class="button__submit">Send Reset Instructions &rarr;</button>
        </form>
        <p>
            <router-link to="login" class="password-link">&larr; Back to Login</router-link>
        </p>
      </div>
      <div :style="styles.spinnerContainer" v-if="!emailSent && formSubmitted">
        <Spinner :styles="styles.spinner" />
      </div>
      <div v-if="emailSent && formSubmitted">
        <p :style="styles.submitMessage">We have received your request to reset your password. If an account exists that is associated with the email provided, you should receive an email within the next few minutes with instructions on how to proceed. Thank you.</p>
      </div>
    </div>
  </div>

</template>

<script>
import { postResource, getResource } from '../../services/Utils';
import store from '../../store';
import ls from 'local-storage';
import Spinner from '../general/Spinner';
export default {
  name: 'resetPassword',
  components: {
    Spinner
  },
  data() {
    return {
      emailSent: false,
      formSubmitted: false,
      validToken: false,
      email: '',
      pswd1: '',
      pswd2: '',
      token: this.$route.params.tokenId,
      styles: {
        container: {
          display: 'flex',
          flexDirection: 'column',
          background: '#f5f5f5',
          height: '100vh',
          boxShadow: '0 0 40px 10px rgba(0,0,0,0.2)',
          width: '60vw',
          flexWrap: 'nowrap',
          alignItems: 'center',
          justifyContent: 'center'
        },
        spinner: {
          position: 'relative',
          marginTop: '40px'
        },
        form: {
          padding: '1rem'
        },
        inputWrap: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        inputLabel: {
          color: '#888',
          fontSize: '0.8em',
          fontWeight: 700,
          textTransform: 'uppercase',
          margin: '10px 0 10px'
        },
        input: {
          margin: 'auto',
          padding: '15px',
          margin: '0 0 10px',
          outline: 'none',
          boxShadow: 'none',
          borderRadius: '4px',
          border: '1px solid #aaa',
          width: '400px'
        },
        button: {
          marginTop: '10px'
        },
        submitMessage: {
          maxWidth: '600px',
          textAlign: 'center',
          lineHeight: '1.5',
          color: '#555'
        }
      }
    };
  },
  methods: {
    submitNewPassword() {
      if (this.pswd1 !== this.pswd2) {
        return alert('Passwords do not match. Please try again');
      }

      postResource('/v1/auth/reset/2', '', {
        tokenId: this.token,
        value: this.pswd1
      })
        .then(res => {
          if (res.status === 'success') {
            ls.set('GEG__KEY', res.token);
            this.$router.push({ name: 'dashboard' });
          }
        })
        .catch(err => {
          console.log(err);
          this.$router.push({ name: 'resetPassword' });
        });
    },

    submitReset() {
      if (!this.email || !this.email.length)
        return alert('Please enter a valid email and try again.');

      this.formSubmitted = true;

      const domain = store.getters.getDomain;
      const tenantId = store.getters.getTenant._id;

      postResource('/v1/auth/reset/1', '', {
        email: this.email,
        domain,
        tenantId
      })
        .then(res => {
          console.log(res);
          this.emailSent = true;
        })
        .catch(err => console.log(err));
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.button__submit {
  margin: 40px auto 20px;
}

.password-link {
  color: #aaa;
  font-size: 1em;
  text-align: center;
  display: block;
  text-decoration: none;
  margin: 0 auto 0;
  &:hover {
    color: #09a3ed;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/ResetPassword.vue